module.exports = __webpack_public_path__ + "assets/img/thumb-Kitome-Blog.0d15978b.webp";